module.exports = __webpack_public_path__ + "img/Impacs to ESS-Impact definition.313613fa.svg";